function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Slider v0.1.0
 *
 * Copyright brandung GmbH & Co.KG
 *
 * Date: 2017-01-31
 * MIT License (MIT)
 *
 * @see http://idangero.us/swiper/api/
 */
import Swiper from 'swiper';
import Capitan from '../../code/js/Capitan/Capitan';
import CapSmartResize from '../../code/js/Capitan/es6/CapSmartResize';
var _ = {
  defaults: {
    componentSelector: '.swiper-thumbs',
    selectors: {
      thumbs: '.swiper-thumbs__thumbnails',
      preview: '.swiper-thumbs__preview'
    }
  }
};
var o = _.defaults;
export function init() {
  if (document.querySelector(o.componentSelector)) {
    var components = document.querySelectorAll(o.componentSelector);
    var imgInSvg = document.querySelectorAll("".concat(o.componentSelector, " svg image"));
    var invertImgInSvg = document.querySelectorAll(".u-bg-color--rich-blue ".concat(o.componentSelector, " svg image"));

    _toConsumableArray(imgInSvg).forEach(function (el) {
      el.parentElement.classList.add('u-svg-filter');
    });

    _toConsumableArray(invertImgInSvg).forEach(function (el) {
      el.parentElement.classList.add('u-svg-filter--invert');
    });

    for (var index = 0; index < components.length; index += 1) {
      var swiperClassList = components[index].classList;
      var swiperClass = 'swiper-thumbs-' + index;
      swiperClassList.add(swiperClass);
      var galleryThumbs = new Swiper(".".concat(swiperClass, " .swiper-thumbs__thumbnails"), {
        direction: 'horizontal',
        slidesPerView: 'auto',
        touchRatio: 0.2,
        speed: 100,
        centeredSlides: false,
        centerInsufficientSlides: true,
        slideToClickedSlide: true,
        spaceBetween: 50,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        updateOnImagesReady: true,
        navigation: {
          nextEl: '.swiper-thumbs__thumbnails' + ' .swiper-button-next',
          prevEl: '.swiper-thumbs__thumbnails' + ' .swiper-button-prev'
        },
        on: {
          init: function init(a) {
            var _this = this;

            _this.el.classList.add('is-init');

            console.log('init swiper gallery thumbnails');
          }
        }
      });
      var galleryTop = new Swiper(".".concat(swiperClass, " .swiper-thumbs__preview"), {
        direction: 'horizontal',
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 10,
        speed: 100,
        slideToClickedSlide: true,
        watchSlidesVisibility: true,
        // Disable preloading of all images
        preloadImages: false,
        // Enable lazy loading
        lazy: true,
        thumbs: {
          swiper: galleryThumbs
        },
        navigation: {
          nextEl: '.swiper-thumbs__preview' + ' .swiper-button-next',
          prevEl: '.swiper-thumbs__preview' + ' .swiper-button-prev'
        },
        on: {
          init: function init(a) {
            var _this = this;

            _this.el.classList.add('is-init');

            console.log('init swiper gallery preview');
          }
        }
      });
      galleryTop.update();
    }
  }
}